import {Nullable} from 'common/types';
import {getEnv} from 'environment/public.environment';

export const getAppLanguage = (nextLocale?: string) => {
  if (nextLocale && getEnv().language.supported.includes(nextLocale)) {
    return nextLocale;
  } else {
    return getEnv().language.default;
  }
};

export const getCountryName = (lng: string, code: Nullable<string>): Nullable<string> => {
  if (!code) {
    return null;
  }
  return new Intl.DisplayNames([lng], {type: 'region'}).of(code);
};

const ISO_639_2: Record<string, string> = {
  nb: 'NOB',
  nn: 'NNO',
  en: 'ENG',
};

export const getAppLanguage_Iso639_2 = (nextLocale: string): string => {
  return ISO_639_2[getAppLanguage(nextLocale)] || ISO_639_2[getEnv().language.default];
};
